<template>
  <div class="order-manager">
    <div class="white-box order-manager-table">
      <p class="title">订单列表</p>
      <table class="xmly-table">
        <thead>
            <tr>
                <th style="width: 300px;">商品名称</th>
                <th style="width: 100px;">商品类型</th>
                <th>用户</th>
                <th>订单状态</th>
                <th>订单金额（元）</th>
                <th>分成比例</th>
                <th>佣金（元）</th>
                <th>渠道</th>
                <th>创建时间</th>
            </tr>
        </thead>

        <tbody :key="order.orderNo" v-for="order in orderTableData">
            <tr class="order">
                <td>{{`订单编号：${order.orderNo}`}}</td>
            </tr>
            <tr>
                <td class="column-content">
                    <div class="pic">
                        <img :src="order.coverUrl">
                    </div>
                    <div class="info">
                        <h2 class="tit elli">{{order.commodityName}}</h2>
                        <p class="price elli">{{`售价：￥${order.orderAmount}`}}</p>
                    </div>
                </td>
                <td>{{order.commodityType}}</td>
                <td>
                    <p class="name elli">{{order.buyerNickName}}</p>
                    <p class="tel elli">{{order.buyerMobile}}</p>
                </td>
                <td>{{order.orderStatus == 2 ? '订单成功': (order.orderStatus == 5 ? '已退款': '')}}
                </td>
                <td>{{`￥${order.orderAmount}`}}</td>
                <td>{{order.rate}}</td>
                <td>{{`￥${order.brokerageAmount}`}}</td>
                <td v-if="promotorType == 1">{{order.promotorName.split('-')[0] == '城市合伙人' ? `城市服务商-${order.promotorName.split('-')[1]}` : order.promotorName}}</td>
                <td v-if="promotorType == 2">{{order.promotorName.split('-')[1]}}</td>
                <td>{{order.createdAt}}</td>
            </tr>
          </tbody>
        </table>
    </div>
    <div class="order-manager-pag column-content white-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="curPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next"
        :total="totalRecords">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { deleteEmptyObj , getFormatTime } from 'utils'
  import { orderMgmtLock } from 'api'
    export default {
      data(){
        return {
          pageSize: 20,
          curPage: 1,
          totalRecords: 0,
          loading:false,
          orderTableData:[]
        }
      },
      components:{

      },
      computed: {
        ...mapGetters([
          'HOST',
          'PROTOCOL',          
          'promotorType'
        ])
      },
      created(){
        let vis = this
        vis.handleSubmit()
      },
      methods:{
        handleSizeChange(){
          this.pageSize = arguments[0];
          this.handleSubmit()
        },
        handleCurrentChange(){
          this.curPage = arguments[0];
          this.handleSubmit()
        },
        handleSubmit(){
          let vis = this
          vis.loading = true
          let temp = {}
          temp['curPage'] = vis.curPage
          temp['pageSize'] = vis.pageSize
          orderMgmtLock(deleteEmptyObj(temp)).then(res=>{
            vis.loading = false
            if(res.ret==0){
              const resData = res.data
              const orders = vis.handleOrderData(resData.lockOrderList)
              vis.orderTableData = orders
              vis.totalRecords = resData.totalRecords
            }
          }).catch(()=>{})
        },
        handleOrderData(data){
          if(data){
            data.map(item=>{
              for(let i in item){
                if(i=='commodityType'){
                  item[i] = item[i] == 1 ? '单集购买' : (item[i] == 2 ? '付费订阅': '巅峰会员')
                }else if(i=='createdAt'){
                  item[i] = getFormatTime(item[i])
                }
              }
            })
          }else{
            data = []
          }
          return data
        }
      }
    }
</script>

<style lang="scss" scoped>
.order-manager{
  &>div{
    width: 960px;
  }
  div.part{
    display: inline-block;
  }
  .el-input__icon+.el-input__inner{
    padding-right:26px;
  }

  .choose-time{
    margin-right: 20px;
  }
  .el-button--primary{
    margin-left: 0px;
    margin-right: 20px;
  }
  .order-manager-search{
    padding:20px;
    height: 235px;
    line-height: 50px;
    .el-input,.el-select{
      margin:0 55px 0 0px;
      width:200px;
    }
    .el-date-editor{
      width:130px;
      margin-right: 0px;
      margin-left: 0px;
    }

    span.span-14{
      display: inline-block;
      width: 75px;
      text-align: left;
    }
  }
  .order-manager-table{
    margin-top: 10px;
    .title{
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #333333;
      height: 50px;
      line-height: 50px;
      padding-left: 20px;
      border-bottom:1px solid #e8e8e8;
    }
  }
  .order-manager-pag{
    margin-top: 10px;
    height: 74px;
  }
}


 table{
     border:none;
     border-collapse: collapse;
     border-spacing: 0;
 }
 .xmly-table{
     background:#fff;
 }
 .xmly-table thead tr{
     font-size: 14px;
     color:#999;
     background:#fff;
     border-bottom: 10px solid #fafafa;
 }
 .xmly-table thead th{
     font-weight: normal;
     padding:10px 20px;
 }


 .xmly-table tbody tr{
     margin-top:10px;
     font-size:14px;
     color:#666;
     background:#fff;
     border-bottom:10px solid #fafafa;
     text-align: center;
 }
  .xmly-table tbody tr:last-child{
      border-bottom:none;
  }
 .xmly-table tbody tr td{
     padding:15px 10px 8px;
 }
 .xmly-table tbody .order{
    border-bottom:none;
    white-space: nowrap;
 }
.xmly-table tbody .order td{
     padding:10px 20px 0;
     font-size: 12px;
     color: #666;
 }
 .xmly-table tbody .order td:before{
     content:'';
     display: inline-block;
     width: 3px;
     height: 14px;
     background: #f86442;
     vertical-align: bottom;
     margin-right:8px;
 }
 .xmly-table tbody tr td .elli{
     max-width: 100px;
 }
 .xmly-table .pic{
     width:50px;
     height:50px;
     display: inline-block;
     margin-right:5px;
 }
 .xmly-table .pic img{
      width:100%;
      height:100%;
  }
 .xmly-table .info{
     display: inline-block;
     text-align: left;
 }
 .xmly-table .info .elli{
     max-width: 200px;
 }
 .xmly-table .info .tit{
    margin:0;
     font-size:12px;
     color:#333;
 }

 .elli{
     white-space: nowrap;
     overflow: hidden;
     text-overflow: ellipsis;
     vertical-align: middle;
 }
</style>





// WEBPACK FOOTER //
// lock.vue?30abfe1f